module.exports = __webpack_public_path__ + "static/media/imgop_supergen-logo.0b87edfe.jp2";